// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-container {
  min-height: -moz-fit-content;
  min-height: fit-content;
  min-width: 250px;
  width: 45vw;
  display: flex;
  flex-direction: column;
}
.dialog-container .mat-dialog-actions {
  margin-top: 1rem;
  margin-bottom: 0.1rem;
}
.dialog-container .title-container {
  display: inline-block;
}
.dialog-container .icon-text-center {
  vertical-align: middle;
  margin-right: 1rem;
}
.dialog-container p {
  text-align: center;
  color: var(--faded-text);
}

@media only screen and (max-width: 1279px) {
  .fxFlex-49-100md {
    flex: 1 1 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
}
@media only screen and (min-width: 1280px) {
  .fxFlex-49-100md {
    flex: 1 1 49%;
    max-width: 49%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 599px) {
  .fxFlex-48-100xs {
    flex: 1 1 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  .fxFlex-30-100xs {
    flex: 1 1 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
}
@media only screen and (min-width: 600px) {
  .fxFlex-48-100xs {
    flex: 1 1 48%;
    max-width: 48%;
    box-sizing: border-box;
  }
  .fxFlex-30-100xs {
    flex: 1 1 30%;
    max-width: 30%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 959px) {
  .fxFlex-49-100sm {
    flex: 1 1 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
}
@media only screen and (min-width: 960px) {
  .fxFlex-49-100sm {
    flex: 1 1 49%;
    max-width: 49%;
    box-sizing: border-box;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/add-cv/add-cv-lang-dialog/add-cv-lang-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EAAA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,gBAAA;EACA,qBAAA;AACJ;AAEE;EACE,qBAAA;AAAJ;AAGE;EACE,sBAAA;EACA,kBAAA;AADJ;AAIE;EACE,kBAAA;EACA,wBAAA;AAFJ;;AAQA;EAIE;IAEE,cAAA;IACA,eAAA;IACA,sBAAA;EATF;AACF;AAcA;EAIE;IAEE,aAAA;IACA,cAAA;IACA,sBAAA;EAhBF;AACF;AAqBA;EACE;IACE,cAAA;IACA,eAAA;IACA,sBAAA;EAnBF;EAsBA;IAEE,cAAA;IACA,eAAA;IACA,sBAAA;EArBF;AACF;AA0BA;EACE;IACE,aAAA;IACA,cAAA;IACA,sBAAA;EAxBF;EA2BA;IACE,aAAA;IACA,cAAA;IACA,sBAAA;EAzBF;AACF;AA6BA;EAGE;IACE,cAAA;IACA,eAAA;IACA,sBAAA;EA7BF;AACF;AAkCA;EAGE;IACE,aAAA;IACA,cAAA;IACA,sBAAA;EAlCF;AACF","sourcesContent":[".dialog-container {\r\n  min-height: fit-content;\r\n  min-width: 250px;\r\n  width: 45vw;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  .mat-dialog-actions {\r\n    margin-top: 1rem;\r\n    margin-bottom: 0.1rem;\r\n  }\r\n\r\n  .title-container {\r\n    display: inline-block;\r\n  }\r\n\r\n  .icon-text-center {\r\n    vertical-align: middle;\r\n    margin-right: 1rem;\r\n  }\r\n\r\n  p {\r\n    text-align: center;\r\n    color: var(--faded-text);\r\n  }\r\n}\r\n\r\n\r\n// Media query za site uredi pomali od 1280px (xs, sm i md uredi)\r\n@media only screen and (max-width:1279px) {\r\n\r\n\r\n  // Za site uredi\r\n  .fxFlex-49-100md {\r\n\r\n    flex: 1 1 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n\r\n  }\r\n}\r\n\r\n// Media query za site uredi pogolemi od 1280px (lg i xl uredi)\r\n@media only screen and (min-width:1280px) {\r\n\r\n\r\n  // Za site uredi\r\n  .fxFlex-49-100md {\r\n\r\n    flex: 1 1 49%;\r\n    max-width: 49%;\r\n    box-sizing: border-box;\r\n\r\n  }\r\n}\r\n\r\n//Media query za site uredi pomali od 599px (xs uredi)\r\n@media only screen and (max-width: 599px) {\r\n  .fxFlex-48-100xs {\r\n    flex: 1 1 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .fxFlex-30-100xs {\r\n\r\n    flex: 1 1 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n}\r\n\r\n//Media query za site uredi pogolemi od 600px (sm, md, lg i xl uredi)\r\n@media only screen and (min-width: 600px) {\r\n  .fxFlex-48-100xs {\r\n    flex: 1 1 48%;\r\n    max-width: 48%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .fxFlex-30-100xs {\r\n    flex: 1 1 30%;\r\n    max-width: 30%;\r\n    box-sizing: border-box;\r\n  }\r\n}\r\n\r\n// Media query za site uredi pomali od 960px (xs i sm uredi)\r\n@media only screen and (max-width: 959px) {\r\n\r\n\r\n  .fxFlex-49-100sm {\r\n    flex: 1 1 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n}\r\n\r\n// Media query za site uredi pogolemi od 960px (md, lg i xl uredi)\r\n@media only screen and (min-width: 960px) {\r\n\r\n\r\n  .fxFlex-49-100sm {\r\n    flex: 1 1 49%;\r\n    max-width: 49%;\r\n    box-sizing: border-box;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
